import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';

import uniqueId from 'lodash/uniqueId';

import KrService from '../../../services/kr.service';
import { useTranslation } from 'react-i18next';
const krService = new KrService();

const OKRWorkstreamSection = ({ goalId }: any) => {
    const [workStream, setWorkStream] = useState(Array);
    const { t } = useTranslation()
    const getGoalWorkstreams = (p: any = {}) => {
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        krService.getGoalWs(p)
            .then((response) => {
                setWorkStream(Object.values(response.data[0].goals.goal_ws))
                removeLoader();
            })
            .catch((err: any) => {
                console.log('err', err);
                removeLoader();
            });
    }

    useEffect(() => {
        const params = { goalId, json: 1 }
        getGoalWorkstreams(params);
    }, []);

    const WorkStreamList = (props) => {
        const { workstream } = props;
        console.log('props -->', props);
        return (
            <div className="okr_workstream_block" id={`ws-${workstream.ws_id}`} role="row">
                <div className="ws_column_workstream" role="cell">
                    <div className="ws_tag_name" data-tip={workstream.tag_name}>
                        <a
                            target="_blank"
                            href={`${wbConfig.baseUrl}/activity/workstreams?id=${workstream.ws_id}`}
                            rel="noreferrer"
                        >
                            {workstream.tag_name}
                        </a>
                    </div>
                    <ReactTooltip />
                </div>
                <div className="ws_column_team" role="cell">
                    <div data-tip={workstream.teamName} aria-label={workstream.teamName}>{workstream.teamName}</div>
                    <ReactTooltip />
                </div>
                <div
                    className="ws_column_health"
                    data-check={workstream.health_text}
                    role="cell"
                    aria-label={workstream.health_text}
                >
                    {workstream.health_text}
                    <div className="ws_column_health_icon" />
                </div>
                {workstream.progress ? (
                    <div className="ws_column_completion" role="cell" aria-label={workstream.progress}>
                        {workstream.progress}%
                    </div>)
                    : <></>}
                {
                    workstream.risk_count && (
                        <div className="ws_column_risk" role="cell" aria-label={workstream.redRag}>
                            {workstream.redRag}
                            {
                                workstream.redRag != '0'
                                    ? <div className="ws_column_risk_icon" />
                                    : <></>
                            }
                        </div>
                    )
                }
            </div>
        );
    }

    return (
        <div className="okr_workstream_section" role="table">
            <div role="rowgroup">
                <div className="okr_workstream_header" role="row">
                    <div className="okr_workstream_header_column column_workstream" role="columnheader">
                        {t('Workstreams')}
                    </div>
                    <div className="okr_workstream_header_column column_team" role="columnheader">{t('Team')}</div>
                    <div className="okr_workstream_header_column column_health" role="columnheader">{t('Health')}</div>
                    <div className="okr_workstream_header_column column_completion" role="columnheader">{t('Completion')}</div>
                    <div className="okr_workstream_header_column column_risk" role="columnheader">{t('Risk')}</div>
                </div>
            </div>
            <div className="okr_workstream_list" role="rowgroup">
                {workStream.map((workstream: any, index: number) =>
                    <WorkStreamList workstream={workstream} key={uniqueId} />)}
            </div>
        </div>
    )
}

export default OKRWorkstreamSection;
